/**
 * StatCard — Displays a single metric with label and optional trend.
 *
 * Props:
 *   label: string — metric name (e.g., "Transactions")
 *   value: string | number — the metric value
 *   prefix: string — prefix like "$" (optional)
 *   change: { value: string, direction: 'up' | 'down' } — trend (optional)
 */

import React from 'react';
import Card from './Card';
import styles from './StatCard.module.css';

function StatCard({ label, value, prefix, change }) {
  return (
    <Card padding="md">
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>
        {prefix && <span className={styles.prefix}>{prefix}</span>}
        {value}
      </div>
      {change && (
        <div className={`${styles.change} ${styles[change.direction]}`}>
          {change.direction === 'up' ? '↑' : '↓'} {change.value}
        </div>
      )}
    </Card>
  );
}

export default StatCard;
